import { useTranslation } from 'next-i18next';
import { FC, Fragment, ReactNode } from 'react';

import StyledTypography from './StyledTypography';

export type MessageProps = {
  title: string;
  message: string;
  icon: ReactNode;
};

const Message: FC<MessageProps> = ({ title, message, icon }) => {
  const { t } = useTranslation('property');

  return (
    <Fragment>
      {icon}
      <StyledTypography
        variant='subtitle2'
        weight='semibold'
        align='center'
      >
        {t(title)}
      </StyledTypography>
      <StyledTypography
        variant='subtitle2'
        weight='semibold'
        align='center'
      >
        {t(message)}
      </StyledTypography>
    </Fragment>
  );
};

export default Message;
